// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__T4sGD","info":"footer_info__6AdE+"};